import { useQuery } from '@tanstack/react-query';
import { deploymentsApi, DeploymentDetail } from '../api/deploymentsApi';

export const deploymentQueryKey = (id: string) => ['deployment', id];

export const useDeployment = (id: string | undefined) => {
  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery<DeploymentDetail>({
    queryKey: deploymentQueryKey(id ?? ''),
    queryFn: () => deploymentsApi.get(id as string),
    enabled: !!id,
  });

  return {
    deployment: data ?? null,
    isLoading,
    error: error as Error | null,
    refetch,
  };
};
